module.exports = "/packs/course-small-freelance-1e3e3b7f8855e4eeb57e8ad3ba69e8f3.png";